import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KeyRound, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import s from '../Management.module.scss'

type Props = { name: string; busy: boolean; error: string; onClose: () => void; onConfirm: (pin: string) => void }

export default function OperatorPinResetDialog({ name, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const [pin, setPin] = useState('')
  const valid = /^[0-9]{4}$/.test(pin)
  return <div className={s.overlay}>
    <form className={s.dialog} role="dialog" aria-modal="true" aria-labelledby="operator-pin-reset-title"
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(pin) }}>
      <h2 id="operator-pin-reset-title"><KeyRound size={20} aria-hidden="true" />{tr('Сброс PIN оператора')}</h2>
      <p>{name}</p>
      <p className={s.muted}>{tr('После сброса оператор задаст новый PIN при следующем входе.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <ActorPinField value={pin} onChange={setPin} disabled={busy} hint="Введите PIN своей учётной записи. PIN оператора не подходит." />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.primary} disabled={busy || !valid}>{tr('Сбросить PIN')}</button>
      </div>
    </form>
  </div>
}
